import React, { useState } from 'react';
import { useMediaQuery } from "react-responsive";
import './SignUp.css';

import { getLocale } from '../../locales/getLocale';
import { plainRetrieve } from '../../utils/safeStoring';
import { getDarkModePreference  } from '../../utils/themes';

import FullLogo from '../../assets/images/full-logo-fatturami.svg';
import SingUpImage from '../../assets/images/sign-up-panel.jpg';
import RocketMail from '../../assets/anims/RocketMail/RocketMail';

import SlInput from '@shoelace-style/shoelace/dist/react/input';
import SlIcon from '@shoelace-style/shoelace/dist/react/icon';
import SlButton from '@shoelace-style/shoelace/dist/react/button';
import SlTooltip from '@shoelace-style/shoelace/dist/react/tooltip';


function SignUp () {

    const isMobileScreen = useMediaQuery({ maxWidth: 700 });

    const appTheme = plainRetrieve('appTheme') || 'system';
    const systemDarkMode = useMediaQuery({ query: '(prefers-color-scheme: dark)' });
    const isDarkMode = getDarkModePreference (appTheme, systemDarkMode);

    const [email, setEmail] = useState('');
    const [voucher, setVoucher] = useState('');
    const [waitingForResponse, setWaitingForResponse] = useState(false);
    const [showVoucherField, setShowVoucherField] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isEmailSent, setIsEmailSent] = useState(false);


    const handleLogin = () => {
        if (showVoucherField) {
            handleVoucherCheck();
        } else {
            handleMailCheck();
        }
    }


    const handleMailCheck = () => {
        setWaitingForResponse(true);

        // call the API to sign-in the user
        const apiUrl = process.env.REACT_APP_API_URL || '';
        const url = `${apiUrl}/api/warden/v1/user_sign_in?mail_address=${email}`;
        fetch(url, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        })
        .then((response) => {
            if (response.status === 200) {
                return response.json();
            } else {
                console.warning(`Error in back-end response: ${response.status} - ${response.json()}`);
            }
        })
        .then((data) => {
            if (data.body) {
                console.log('User was already registered.')
                setIsEmailSent(true);
                setWaitingForResponse(false);
            } else {
                console.log('New user. Requesting voucher...')
                setShowVoucherField(true);
                setWaitingForResponse(false);
            }
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }
    

    const handleVoucherCheck = () => {
        setWaitingForResponse(true);

        // call the sign-up API to add new user
        const apiUrl = process.env.REACT_APP_API_URL || '';
        const url = `${apiUrl}/api/warden/v1/user_sign_up?mail_address=${email}&voucher=${voucher}`;
        fetch(url, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        })
        .then((response) => {
            if (response.status === 200) {
                return response.json();
            } else {
                console.warning(`Error in back-end response: ${response.status} - ${response.json()}`);
            }
        })
        .then((data) => {
            if (data.body) {
                console.log('Sent confirmation e-mail to create new user.')
                setIsEmailSent(true);
                setWaitingForResponse(false);
            } else {
                console.log('Incorrect voucher', data.message);
                setWaitingForResponse(false);
                if (data.message === 'voucher-already-redeemed') {
                    setErrorMessage('Voucher già riscattato');
                } else {
                    setErrorMessage('Codice voucher non valido');
                }
            }
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }


    return (

        <div className={isDarkMode ? 'dark-mode sl-theme-dark sl-theme-dark-fatturami' : 'sl-theme-light sl-theme-fatturami'} style={{ height: 'inherit', minHeight: 'inherit' }}>

            <div className='sign-up-page'>
                
                {!isMobileScreen && (
                    <div className='sign-up-panel-left'>

                        <img className='sign-up-image'
                            src={SingUpImage}
                            alt="Sign up graphics"
                        />

                    </div>
                )}

                <div className='sign-up-panel-right'>

                    <div className='sign-up-panel-right-content'>
                    
                        <img className='logo'
                            src={FullLogo}
                            alt="Logo"
                        />

                        {!isEmailSent ? (

                            <>
                            <p className='login-tagline'>{getLocale('SignUp.tagline')}</p>
                            <p>{getLocale('SignUp.ctaMail')}</p>

                            <SlInput 
                                autofocus
                                placeholder={getLocale('SignUp.placeholderMail')}
                                disabled={showVoucherField}
                                type="email"
                                value={email}
                                onSlInput={(e) => setEmail(e.target.value)}
                            >
                                <SlIcon name="envelope" slot="prefix"></SlIcon>
                            </SlInput>

                            {showVoucherField && (
                                <>
                                    <p>
                                        {getLocale('SignUp.ctaVoucher1')}
                                        <SlTooltip 
                                            content={getLocale('SignUp.ctaVoucherTip')}
                                            style={{ '--max-width': '192px' }}
                                            hoist
                                        >
                                        <u>{getLocale('SignUp.ctaVoucher2')}</u>
                                        </SlTooltip>
                                    </p>
                                    <SlInput
                                        placeholder={getLocale('SignUp.placeholderVoucher')}
                                        help-text={getLocale('SignUp.helpTextVoucher')}
                                        value={voucher}
                                        onSlInput={(e) => setVoucher(e.target.value)}
                                    >
                                        <SlIcon name="gift" slot="prefix"></SlIcon>
                                    </SlInput>
                                </>
                            )}

                            {errorMessage && (errorMessage.length > 0) && (
                                <div className='error-message'>
                                    <SlIcon name="exclamation-diamond"></SlIcon>
                                    <span>{errorMessage}</span>
                                </div>
                            )}

                            <SlButton  
                                className='login-button'
                                variant="primary" 
                                loading={waitingForResponse}
                                disabled={(email.length === 0) || (showVoucherField && voucher.length === 0)}
                                onClick={() => handleLogin()}
                            >
                                {getLocale('SignUp.loginBtn')}
                            </SlButton>
                            </>
                        
                        ) : (

                            <div className='sent-email-container'>
                                <h3>{getLocale('SignUp.sentEmail1')}</h3>
                                <RocketMail />
                                <p>{getLocale('SignUp.sentEmail2')}<br/><strong>{email}</strong></p>
                            </div>
                        
                        )}
                        

                        <small className='ask-support'>
                            {getLocale('SignUp.askSupport')}<br/>
                            <a href={`mailto:${getLocale('SignUp.supportMail')}`}>{getLocale('SignUp.supportMail')}</a>
                        </small>
                    
                    </div>

                </div>
            </div>
        
        </div>
);
}

export default SignUp;
